export const options = [5, 10, 15, 25, 50];
